import { handleDeleteRequest, handleGetRequest, handlePostRequest, handlePutRequest } from '.';
import { URI } from '../../constants/URI';
import { setLabels } from '../slices/labelsSlice';
import { store } from '../store';

export const getLabels = async ({ id }) => {
  const res = await handleGetRequest(URI.label_by_id(id), null, {
    toast: false,
  });
  if (res?.ack) store.dispatch(setLabels(res?.labels));
  return res;
};

export const addLabel = async (body) => {
  const res = await handlePostRequest(URI.label, body);
  if (res) getLabels({ id: body.restaurant_id });
  return res;
};

export const updateLabel = async (body) => {
  const res = await handlePutRequest(URI.label, body);
  if (res) getLabels({ id: body.restaurant_id });
  return res;
};

export const deleteLabel = async (id, restaurant_id) => {
  const res = await handleDeleteRequest(URI.label_by_id(id));
  if (res) getLabels({ id: restaurant_id });
  return res;
};
